import React, {
  Fragment,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import {
  BoxWithShadow,
  Center,
  Box,
  PeriscopeFailedIcon,
  Heading,
  Paragraph,
  Cover,
  Spinner,
} from "@thecb/components";
import S from "sanctuary";
import { connect } from "react-redux";
import { DashboardIFrame } from "./PeriscopeDashboard.styled";
import { getDashboardUrl } from "./PeriscopeDashboard.state";
import {
  requestPeriscopeDashboard,
  getPeriscopeDataPending,
  getPeriscopeDataSuccess,
  getPeriscopeDataFailure,
  periscopeDataRequestSuccess,
  periscopeDataRequestFailure,
} from "@/components/periscopeDashboard/PeriscopeDashboard.state";

const DASHBOARD_SIZE_MESSAGE_TYPE = "dashboard_resize";
const PERISCOPE_ORIGIN = "https://app.periscopedata.com";
const isValidMessage = (message) =>
  message.isTrusted &&
  message.origin === PERISCOPE_ORIGIN &&
  message.data &&
  message.data.event_type === DASHBOARD_SIZE_MESSAGE_TYPE;

const PeriscopeDashboard = ({
  url,
  requestDashboardUrl,
  periscopeDataPending,
  periscopeDataSuccess,
  periscopeDataFailure,
  periscopeDataRequestSuccess,
  periscopeDataRequestFailure,
}) => {
  const [height, setHeight] = useState(0);
  const time = useRef({ timer: null });

  useEffect(() => {
    time.current.timer = setTimeout(() => {
      periscopeDataRequestFailure();
    }, 10000);
  }, [periscopeDataRequestFailure, time]);

  const Dashboard = (height) => (url) => (
    <DashboardIFrame
      src={url}
      width="100%"
      height={height}
      data-qa="DashboardIFrame"
      onLoad={() => {
        let iframe = document.querySelector("iframe");
        iframe.style.display = "initial";
      }}
    />
  );

  const validatePeriscope = useCallback(
    (message) => {
      if (isValidMessage(message)) {
        setHeight(message.data.dashboard_height + 100);
        clearTimeout(time.current.timer);
        periscopeDataRequestSuccess();
      }
    },
    [periscopeDataRequestSuccess]
  );

  useLayoutEffect(() => {
    window.addEventListener("message", validatePeriscope);
    requestDashboardUrl();
    return () => window.removeEventListener("message", validatePeriscope);
  }, [requestDashboardUrl, validatePeriscope]);

  return (
    <Fragment>
      <BoxWithShadow
        padding="0"
        minWidth="100%"
        minHeight="592px"
        variant="baseStandard"
        background="#fff"
        borderRadius="4px"
        extraStyles={`display: flex; justify-content: center; align-items: center; flex-direction: column;`}
      >
        {periscopeDataPending && !periscopeDataSuccess && (
          <Cover minHeight="100%" singleChild>
            <Center intrinsic>
              <Spinner size="100" />
            </Center>
          </Cover>
        )}
        {periscopeDataFailure && !periscopeDataSuccess && (
          <Box padding="64px">
            <Center intrinsic>
              <Box padding="0 0 2rem">
                <PeriscopeFailedIcon />
              </Box>
              <Heading variant="h3" weight="700">
                Something Went Wrong
              </Heading>
              <Paragraph variant="p" extraStyles={`text-align: center;`}>
                There was an issue trying to load the dashboard.
              </Paragraph>
              <Paragraph variant="p" extraStyles={`text-align: center;`}>
                Your organization may not have a dashboard configured.
              </Paragraph>
            </Center>
          </Box>
        )}
        {!periscopeDataFailure &&
          S.pipe([S.map(Dashboard(height)), S.maybeToNullable])(url)}
      </BoxWithShadow>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  url: getDashboardUrl(state),
  periscopeDataPending: getPeriscopeDataPending(state),
  periscopeDataSuccess: getPeriscopeDataSuccess(state),
  periscopeDataFailure: getPeriscopeDataFailure(state),
});
const mapDispatchToProps = (dispatch) => ({
  requestDashboardUrl: () => dispatch(requestPeriscopeDashboard()),
  periscopeDataRequestSuccess: () => dispatch(periscopeDataRequestSuccess()),
  periscopeDataRequestFailure: () => dispatch(periscopeDataRequestFailure()),
});
export default connect(mapStateToProps, mapDispatchToProps)(PeriscopeDashboard);
